<template>
  <div>
    <header id="masthead" class="registration">
      <div class="wp1200">
        <a class="logo" href></a>
        <div v-if="showToastError">
          <div
            style="
              margin-bottom: 25px;
              padding: 20px;
              background-color: #ef5451;
              border-radius: 20px;
              color: white;
              display: -webkit-flex;
              display: flex;
              align-items: center;
            "
          >
            <span
              class="warpit_icon_alert"
              style="font-size: 32px; margin-right: 15px"
            ></span>
            {{ showToastMessage }}
          </div>
        </div>
      </div>
    </header>
    <section>
      <div class="wp1200">
        <div class="onBoardRegistration passReset">
          <hr class="blue" />
          <h4>Sprememba elektronskega naslova</h4>
          <p>{{ bannerText }}</p>

          <form action="#" class="custom-form">
            
            <div
              class="form-group"
              v-bind:class="{ 'not-empty': !isEmailEmpty }"
            >
              <input
                type="text"
                class="form-control"
                name="email"
                id="email"
                v-model="form.email"
                required
                @blur="formUtilsCheckEmail()"
              />
              <label for="email" class="animated-label"
                >Elektronski naslov</label
              >
              <span class="line"></span>
            </div>

            <span class="errorSexTxt" v-if="errors.email" for="email">{{ $t("error.email_missing") }}</span>


            <div class="next flex">
              <a class="txt" href v-on:click.prevent="formUtilsCancel()">Prekličite</a>
              <a
                class="join smallFont smallWidth hoverEffect"
                ref="joinButton1"
                v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton1')"
                v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton1')"
                v-on:click.prevent="onSubmit()"
                href="javascript:void(0);"
              >
                <label>Potrdite</label>
                <span
                  class="effect"
                  ref="effectButton1"
                  v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"
                ></span>
              </a>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

import { formUtilsCheckEmail, formUtilsMouseHoverEffect, formUtilsCancel} from '@/utils/form_utils.js';

export default {
  data() {
    return {
      showToastError: false,
      showToastMessage: "",
      bannerText:
        "Hhas dhags dhgas dhgas dhgas dhg asdh. Hhas dhags dhgas dhgas dhgas dhg asdh.Hhas dhags dhgas dhgas dhgas dhg asdh. Hhas dhags dhgas dhgas dhgas dhg asdh. Hhas dhags dhgas dhgas dhgas dhg asdh.",
      isEmailEmpty: true,
      email: "",

      form: {
        email: "",
        name: "",
        surname: "",
        dateOfBirth: "",
        sex: null,
        created: "",
        profilePhoto: null,
        recaptchaToken: ''
      },
      topX: 1,
      leftX: 1,
      errors: {
        email: false,
      },
    };
  },

  mounted() {
    this.loadUser();
  },

  methods: {
    formUtilsCheckEmail,
    formUtilsMouseHoverEffect,
    formUtilsCancel,

    async onSubmit() {
      /* CHECK FIELDS BEFORE SUBMIT */
      this.formUtilsCheckEmail();
      if (this.errors.email === true) {
        return;
      }

      /* CHECK CAPTCHA */
      this.$checkRecaptcha().then((token) => {
        this.sendForm(token);
      }).catch((error) => {
        console.error("Error reCAPTCHA:", error);
      });
    },

    async sendForm(recaptchaToken) {
      this.form.recaptchaToken = recaptchaToken;

        await this.$http
          .put("api/v1/userinfo", this.form)
          .then(() => {
            this.$store.dispatch("user/userinfo");
            this.$router.back();
            return;
          })
          .catch(() => {
            this.showToastMessage = "Invalid update.";
            this.showToastError = true;
          });
      
    },

    loadUser() {
      let data = this.$store.getters["user/user"];
      for (const element in this.form) {
        if (
          this.form.hasOwnProperty(element) === false ||
          data.hasOwnProperty(element) === false
        ) {
          continue;
        }

        this.form[element] = data[element];
      }
    },



  },
};
</script>

<style scoped>
h2 {
  color: #000000 !important ;
}
</style>
